import React from "react";
import { Text } from "react-native";
import Hyperlink from "react-native-hyperlink";
import {
    SectionWrapper,
    SectionPageTitle,
    SectionText,
    SectionTitle,
    BulletInlineText,
    BulletInlineRowText,
} from "./styles";

const HomeSetupContent = () => {
    const linkStyle = {
        color: "#2980b9",
        fontSize: 16,
    };
    const openLink = (url) => {
        window.open(url);
    };

    return (
        <SectionWrapper>
            <Hyperlink linkStyle={linkStyle} onPress={(url) => openLink(url)}>
                <SectionPageTitle>Openbrix.co.uk/* - including tlyfe</SectionPageTitle>
                <SectionText style={{ fontWeight: 'bold', fontSize: 24, marginTop: 24 }}>
                    tlyfe Home Setup – Terms and Conditions
                </SectionText>

                <SectionTitle>1 About Us</SectionTitle>
                <SectionText>
                    A. Tlyfe is a product provided by OPENBRIX LIMITED (Companies House number 11305881) (the Company, the Supplier, we and us) which is a company registered in England and Wales and our registered office is at 40 - 42 Regent Street, Clifton, Bristol, England, BS8 4HU. We operate the website www.openbrix.co.uk (the Site).
                </SectionText>
                <SectionText>
                    B. To contact us, you should email our customer service team at customerservices@openbrix.co.uk. Our Postal Address is: 4-5 Quay Point, Northharbour Road, Portsmouth, Hampshire, PO6 3TD.
                </SectionText>

                <SectionTitle>2 - Home Setup Suppliers</SectionTitle>
                <SectionText>
                    A. Tlyfe users have a choice to receive free home concierge service from a supplier selected by OpenBrix.
                </SectionText>
                <SectionText>
                    B. One of the following Suppliers will be used
                </SectionText>

                <BulletInlineText>
                    <Text>• Home.cc (https://my.home.cc/terms)</Text>
                </BulletInlineText>
                <BulletInlineText>
                    <Text>• Just Move in (https://justmovein.com/ts-and-cs)</Text>
                </BulletInlineText>

                <SectionText>
                    C: By agreeing to the free home setup concierge service you are agreeing to the term of the home setup company whom we send your information to.
                </SectionText>
            </Hyperlink>
        </SectionWrapper>
    );
};

export default HomeSetupContent;
